import { getHsUsers } from '../../../HttpRequests/ramsControlCentre'
import { setHsUsers } from '../State/hsUsers'

export default () => (dispatch) => {
  return getHsUsers()
    .then(({ data }) => {
      dispatch(setHsUsers(data.data || []))
    })
    .catch((error) => {
      console.error('Failed to fetch H&S users:', error)
      dispatch(setHsUsers([]))
    })
}
